import React from 'react';

import { Grid, Typography } from '@mui/material';

import HeaderBackground from 'src/assets/images/backgrounds/HeaderBackground.jpg';
import { DEFAULT_BORDER } from 'src/constants';

export type DashboardTitleProps = {
    title: string;
    subTitle: React.ReactNode;
    actions?: React.ReactNode;
};

export default function DashboardTitleSection({
    title,
    subTitle,
    actions = <></>,
}: Readonly<DashboardTitleProps>) {
    return (
        <Grid
            item
            xs={12}
            container
            sx={{
                ...DEFAULT_BORDER,
                height: '116px',
                backgroundColor: '#FFFFFF',
                boxShadow: '0px 4px 20px rgba(38,50,56,0.1)',
                padding: '12px 24px',
                alignItems: 'center',
                backgroundImage: `url(${HeaderBackground})`,
            }}
            data-testid={'dashboard-title-section'}
        >
            <Grid item xs={7}>
                <Typography sx={{ fontSize: '24px', fontWeight: 700, color: '#1D1D1B', mb: '8px' }}>
                    {title}
                </Typography>
                <Typography sx={{ fontSize: '21px', fontWeight: 400, color: '#F18F34' }}>
                    {subTitle}
                </Typography>
            </Grid>

            <Grid item xs={5} display="flex" justifyContent="right" gap={2}>
                {actions}
            </Grid>
        </Grid>
    );
}
